module.exports = "<button type=\"button\" class=\"layui-btn\" id=\"{{fieldName}}\">\r\n    <i class=\"layui-icon\">&#xe67c;</i>上传图片\r\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/template/form/UploadImage.html
// module id = 75
// module chunks = 0